import { type HTMLAttributes, type ReactNode } from 'react';

type Width = 'default' | 'narrow' | 'prose' | 'wide';

const widthClass: Record<Width, string> = {
  default: 'max-w-[var(--container-max)]',
  narrow: 'max-w-[var(--container-narrow)]',
  prose: 'max-w-[var(--container-prose)]',
  wide: 'max-w-[88rem]',
};

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  width?: Width;
}

export function Container({ children, width = 'default', className = '', ...rest }: Props) {
  return (
    <div
      className={`mx-auto w-full px-6 sm:px-8 lg:px-10 ${widthClass[width]} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
